import { ColorProps } from 'types';

// ==============================|| THEME 5 COLORS ||============================== //

const theme5: ColorProps = {
  // paper & background
  paper: '#ffffff',

  // primary
  primaryLight: '#e2e5e8',
  primary200: '#8591a1',
  primaryMain: '#0a2342',
  primaryDark: '#091f3c',
  primary800: '#05152b',

  // secondary
  secondaryLight: '#e6f4f1',
  secondary200: '#96d2c6',
  secondaryMain: '#2ca58d',
  secondaryDark: '#279d85',
  secondary800: '#1b8a70',

  // success
  successLight: '#b9f6ca',
  success200: '#69f0ae',
  successMain: '#00e676',
  successDark: '#00c853',

  // error
  errorLight: '#ef9a9a',
  errorMain: '#f44336',
  errorDark: '#c62828',

  // orange
  orangeLight: '#fbe9e7',
  orangeMain: '#ffab91',
  orangeDark: '#d84315',

  // warning
  warningLight: '#fff8e1',
  warningMain: '#ffe57f',
  warningDark: '#ffc107',

  // grey
  grey50: '#f8fafc',
  grey100: '#eef2f6',
  grey200: '#e3e8ef',
  grey300: '#cdd5df',
  grey500: '#697586',
  grey600: '#4b5565',
  grey700: '#364152',
  grey900: '#121926',

  // ==============================|| DARK THEME VARIANTS ||============================== //

  // paper & background
  darkPaper: '#030c1d',
  darkBackground: '#051327',

  // dark 800 & 900
  darkLevel1: '#071a33',
  darkLevel2: '#091f3c',

  // text variants
  darkTextTitle: '#d7dcec',
  darkTextPrimary: '#bdc8f0',
  darkTextSecondary: '#8492c4',

  // primary dark
  darkPrimaryLight: '#e2e5e8',
  darkPrimaryMain: '#54657b',
  darkPrimaryDark: '#2f445e',
  darkPrimary200: '#8591a1',
  darkPrimary800: '#05152b',

  // secondary dark
  darkSecondaryLight: '#e6f4f1',
  darkSecondaryMain: '#2ca58d',
  darkSecondaryDark: '#279d85',
  darkSecondary200: '#96d2c6',
  darkSecondary800: '#1b8a70'
};

export default theme5;
